import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

function Piechart() {
  const [state, setState] = useState({
    series: [44, 55, 41, 17, 15],
    options: {
      chart: {
        type: "donut",
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  });

  return (
    <div>
      <h1>React Apex Chart</h1>
      <br />
      <br />
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="donut"
        height={350}
        // width={500}
      />
    </div>
  );
}

export default Piechart;
